import { useEffect, useRef } from "react";

type Forge = { destroy: () => void };

/** Ciclul de viață al materialului din hero.
 *
 *  Modulul se aduce dinamic: e ~10 KB de cod de desen care n-are ce căuta în
 *  chunk-ul comun, fiindcă trăiește pe o singură secțiune a unei singure
 *  pagini. Aceeași regulă ca la motorul 3D al paginilor de caz.
 *
 *  Cleanup-ul e obligatoriu, nu opțional: modulul înregistrează listeneri pe
 *  window și document, un IntersectionObserver și un ResizeObserver. Fără
 *  destroy() la demontare, o navigare la /work și înapoi ar lăsa în urmă un rAF
 *  care desenează pe un canvas care nu mai e în pagină. */
export function useForge() {
  const rootRef = useRef<HTMLElement | null>(null);
  const billetRef = useRef<HTMLDivElement | null>(null);
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const h1Ref = useRef<HTMLHeadingElement | null>(null);

  useEffect(() => {
    let forge: Forge | null = null;
    let dead = false;
    const root = rootRef.current;
    const billet = billetRef.current;
    const canvas = canvasRef.current;
    const h1 = h1Ref.current;
    if (!root || !billet || !canvas || !h1) return;

    void import("./heroForge.js").then(
      ({ createForge }: { createForge: (o: unknown) => Forge }) => {
        if (dead) return;
        forge = createForge({ root, billet, canvas, h1 });
      },
    );

    return () => {
      dead = true;
      forge?.destroy();
      forge = null;
    };
  }, []);

  return { rootRef, billetRef, canvasRef, h1Ref };
}
